// extracted by mini-css-extract-plugin
export default {"rightAligned":"styles_rightAligned__kK1kv","customSelect":"styles_customSelect__2rFSm"};